import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => style(theme));

function PanelActions ({ children }) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            {children}
        </div>
    );
}

const style = theme => ({
    root: {
        padding: theme.constants.spacing.xl,
        boxSizing: 'border-box',
        '&> *:not(:last-child)':{
            marginBottom: theme.constants.verticalMargin
        }
    },
    border: {
        height: '2px',
        backgroundColor: theme.palette.background.border
    }
});

export default PanelActions;